import { render, staticRenderFns } from "./hallOfFameHeader.vue?vue&type=template&id=6dcb5566&"
import script from "./hallOfFameHeader.vue?vue&type=script&lang=js&"
export * from "./hallOfFameHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports